export const PROJECT_ROLES = {
    COPILOT: 'copilot',
    CUSTOMER: 'customer',
    MANAGER: 'manager',
    OBSERVER: 'observer',
    READ: 'observer',
    WRITE: 'customer',
} as const

export const PROJECT_MEMBER_INVITE_STATUS = {
    ACCEPTED: 'accepted',
    CANCELED: 'canceled',
    PENDING: 'pending',
    REFUSED: 'refused',
} as const
